import { getGBUrl } from '../utils/config';
import { getFetch } from '../utils/fetch';

export const hasInstructorLinked = async (courseId) => {
  const url = `${getGBUrl()}/api/v1/reef/course/${courseId}/has-instructor-linked`;
  const response = await getFetch(url);
  if (!response.ok) {
    throw new Error(
      `Server request to set users third party lms id failed.  ${response.status} ${response.statusText}`,
    );
  }
  const data = await response.json();
  return data.hasInstructorLinked;
};

export const getCreateCourse = async (courseId) => {
  const gradebookReefServiceUrl = `${getGBUrl()}/api/v1/reef`;

  const url = `${gradebookReefServiceUrl}/course/${courseId}/create`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      redirectHost: window.location.origin,
    }),
  });
  if (!response.ok) {
    throw new Error(
      `Server request to create iClicker course failed.  ${response.status} ${response.statusText}`,
    );
  }
  const rj = await response.json();
  return rj.url.redirectUrl;
};

export const linkReefAccount = async (courseId, info, isInstructor = false) => {
  const gradebookReefServiceUrl = `${getGBUrl()}/api/v1/reef`;
  const path = isInstructor ? 'instructor' : 'student';
  const url = `${gradebookReefServiceUrl}/course/${courseId}/${path}/link`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(info),
  });
  if (!response.ok) {
    if (response.status === 400) {
      throw new Error(
        `Sign in attempt was unsuccessful. Please make sure you are using your iClicker email and password. ${response.status} ${response.statusText}`,
      );
    }

    throw new Error(
      `Server request to link iClicker account failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};

export const unlinkReef = async (courseId, _info, isInstructor = false) => {
  const gradebookReefServiceUrl = `${getGBUrl()}/api/v1/reef`;
  const path = isInstructor ? 'instructor' : 'student';
  const url = `${gradebookReefServiceUrl}/course/${courseId}/${path}/unlink`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Content-Length': 0,
    },
  });
  if (!response.ok) {
    throw new Error(
      `Server request to unlink iClicker account failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};

export const linkReefCourse = async (courseId, info) => {
  const gradebookReefServiceUrl = `${getGBUrl()}/api/v1/reef`;
  const url = `${gradebookReefServiceUrl}/course/${courseId}/link`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(info),
  });
  if (!response.ok) {
    throw new Error(
      `Server request to link iClicker course failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};

export const isUserLinked = async (courseId) => {
  const gradebookReefServiceUrl = `${getGBUrl()}/api/v1/reef`;
  const url = `${gradebookReefServiceUrl}/course/${courseId}/status`;
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(
      `Server request to get user iClicker status failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};

export const getReefCourseList = async (courseId) => {
  const gradebookReefServiceUrl = `${getGBUrl()}/api/v1/reef`;
  const url = `${gradebookReefServiceUrl}/course/${courseId}`;
  const method = 'GET';
  const response = await fetch(url, {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Content-Length': 0,
    },
  });
  if (!response.ok) {
    throw new Error(
      `Server request to get iClicker course list failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};

export const syncReefGrades = async (courseId, info) => {
  const gradebookReefServiceUrl = `${getGBUrl()}/api/v1/reef`;
  const url = `${gradebookReefServiceUrl}/course/${courseId}/gradebook`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(info),
  });
  if (!response.ok) {
    throw new Error(
      `Server request to sync iClicker grades failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};
